webpackJsonp([9],{

/***/ "/hsz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actions = __webpack_require__("cKSt");

var _actions2 = _interopRequireDefault(_actions);

var _getters = __webpack_require__("5AB7");

var _getters2 = _interopRequireDefault(_getters);

var _mutations = __webpack_require__("VkTP");

var _mutations2 = _interopRequireDefault(_mutations);

var _state = __webpack_require__("g8Jr");

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  namespaced: true,
  actions: _actions2.default,
  getters: _getters2.default,
  mutations: _mutations2.default,
  state: _state2.default
};

/***/ }),

/***/ "0ZAb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  byName: function byName(state, name) {
    return state.dharmams.find(function (dharmam) {
      return dharmam.name === name;
    });
  },
  items: function items(state) {
    return state.dharmams;
  }
};

/***/ }),

/***/ "0dPd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actions = __webpack_require__("DvAs");

var _actions2 = _interopRequireDefault(_actions);

var _getters = __webpack_require__("0ZAb");

var _getters2 = _interopRequireDefault(_getters);

var _mutations = __webpack_require__("iMZk");

var _mutations2 = _interopRequireDefault(_mutations);

var _state = __webpack_require__("jTsY");

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  namespaced: true,
  actions: _actions2.default,
  getters: _getters2.default,
  mutations: _mutations2.default,
  state: _state2.default
};

/***/ }),

/***/ "1AQK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _Proxy2 = __webpack_require__("dP9K");

var _Proxy3 = _interopRequireDefault(_Proxy2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthProxy = function (_Proxy) {
    (0, _inherits3.default)(AuthProxy, _Proxy);

    function AuthProxy() {
        var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, _classCallCheck3.default)(this, AuthProxy);
        return (0, _possibleConstructorReturn3.default)(this, (AuthProxy.__proto__ || (0, _getPrototypeOf2.default)(AuthProxy)).call(this, 'api', parameters));
    }

    (0, _createClass3.default)(AuthProxy, [{
        key: 'login',
        value: function login(_ref) {
            var email = _ref.email,
                password = _ref.password;

            var data = {
                email: email,
                password: password
            };

            return this.submit('post', this.endpoint + '/authenticate', data);
        }
    }, {
        key: 'register',
        value: function register(data) {
            return this.submit('post', this.endpoint + '/register', data);
        }
    }]);
    return AuthProxy;
}(_Proxy3.default);

exports.default = AuthProxy;

/***/ }),

/***/ "4HwT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _Transformer2 = __webpack_require__("wz9i");

var _Transformer3 = _interopRequireDefault(_Transformer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccountTransformer = function (_Transformer) {
  (0, _inherits3.default)(AccountTransformer, _Transformer);

  function AccountTransformer() {
    (0, _classCallCheck3.default)(this, AccountTransformer);
    return (0, _possibleConstructorReturn3.default)(this, (AccountTransformer.__proto__ || (0, _getPrototypeOf2.default)(AccountTransformer)).apply(this, arguments));
  }

  (0, _createClass3.default)(AccountTransformer, null, [{
    key: 'fetch',
    value: function fetch(account) {
      return {
        email: account.email,
        firstName: account.first_name,
        lastName: account.last_name
      };
    }
  }, {
    key: 'send',
    value: function send(account) {
      return {
        email: account.email,
        first_name: account.firstName,
        last_name: account.lastName
      };
    }
  }]);
  return AccountTransformer;
}(_Transformer3.default);

exports.default = AccountTransformer;

/***/ }),

/***/ "5AB7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),

/***/ "5W1q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "77GP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _auth = __webpack_require__("eOO6");

var auth = _interopRequireWildcard(_auth);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  auth: auth
};

/***/ }),

/***/ "CZ0x":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actions = __webpack_require__("fHbC");

var _actions2 = _interopRequireDefault(_actions);

var _getters = __webpack_require__("iwwM");

var _getters2 = _interopRequireDefault(_getters);

var _mutations = __webpack_require__("m3mU");

var _mutations2 = _interopRequireDefault(_mutations);

var _state = __webpack_require__("MACa");

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  namespaced: true,
  actions: _actions2.default,
  getters: _getters2.default,
  mutations: _mutations2.default,
  state: _state2.default
};

/***/ }),

/***/ "DP/h":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = [{
    path: '/',
    name: 'home.index',
    component: function component() {
        return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "JNxQ"));
    },

    meta: {
        guest: true
    }
}, {
    path: '/admin',
    name: 'admin.index',
    component: function component() {
        return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "NgpE"));
    },

    meta: {
        auth: true
    }
}, {
    path: '/login',
    name: 'login.index',
    component: function component() {
        return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "7GdE"));
    },

    meta: {
        guest: true
    }
}, {
    path: '/register',
    name: 'register.index',
    component: function component() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "ikTn"));
    },

    meta: {
        guest: true
    }
}, {
    path: '/dharmam/:name',
    name: 'dharmam.index',
    props: true,
    component: function component() {
        return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "GEsH"));
    },

    meta: {
        guest: true
    }
}, {
    path: '/bank/:name',
    name: 'bank.index',
    props: true,
    component: function component() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "Utys"));
    },

    meta: {
        guest: true
    }
}, {
    path: '/dharmams',
    name: 'dharmams.index',
    component: function component() {
        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "hk/d"));
    },

    meta: {
        guest: false,
        auth: true
    }
}, {
    path: '/donation-received',
    name: 'donation.index',

    props: function props(route) {
        return {
            paymentId: route.query.payment_id,
            requestId: route.query.payment_request_id
        };
    },
    component: function component() {
        return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "1oPV"));
    },

    meta: {
        guest: true
    }
}, {
    path: '/*',
    redirect: '/home'
}];

/***/ }),

/***/ "DvAs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.find = undefined;

var _AccountTransformer = __webpack_require__("4HwT");

var _AccountTransformer2 = _interopRequireDefault(_AccountTransformer);

var _mutationTypes = __webpack_require__("Jqq7");

var types = _interopRequireWildcard(_mutationTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var find = exports.find = function find(_ref) {
  var commit = _ref.commit;

  var account = {
    first_name: 'John',
    last_name: 'Doe',
    email: 'jonh@doe.com'
  };

  commit(types.FIND, _AccountTransformer2.default.fetch(account));
};

exports.default = {
  find: find
};

/***/ }),

/***/ "GRgx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vuexRouterSync = __webpack_require__("9JMe");

var _vuexRouterSync2 = _interopRequireDefault(_vuexRouterSync);

var _store = __webpack_require__("IcnI");

var _store2 = _interopRequireDefault(_store);

var _vueRouter = __webpack_require__("sSws");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vuexRouterSync2.default.sync(_store2.default, _vueRouter.router);

/***/ }),

/***/ "IcnI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__("NYxO");

var _vuex2 = _interopRequireDefault(_vuex);

var _logger = __webpack_require__("sax8");

var _logger2 = _interopRequireDefault(_logger);

var _account = __webpack_require__("/hsz");

var _account2 = _interopRequireDefault(_account);

var _auth = __webpack_require__("CZ0x");

var _auth2 = _interopRequireDefault(_auth);

var _dharmams = __webpack_require__("0dPd");

var _dharmams2 = _interopRequireDefault(_dharmams);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var debug = "production" !== 'production';

exports.default = new _vuex2.default.Store({
  modules: {
    account: _account2.default,
    auth: _auth2.default,
    dharmams: _dharmams2.default
  },

  strict: debug,

  plugins: debug ? [(0, _logger2.default)()] : []
});

/***/ }),

/***/ "Jqq7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FIND = exports.FIND = 'FIND';

exports.default = {
  FIND: FIND
};

/***/ }),

/***/ "Kkag":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _store = __webpack_require__("IcnI");

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_axios2.default.defaults.baseURL = "";
_axios2.default.defaults.headers.common.Accept = 'application/json';
_axios2.default.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error.response.status === 401) {
        _store2.default.dispatch('auth/logout');
    }

    return _promise2.default.reject(error);
});

_vue2.default.$http = _axios2.default;
window.axios = _axios2.default;
Object.defineProperty(_vue2.default.prototype, '$http', {
    get: function get() {
        return _axios2.default;
    }
});

/***/ }),

/***/ "M0FW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CHECK = exports.CHECK = 'CHECK';
var REGISTER = exports.REGISTER = 'REGISTER';
var LOGIN = exports.LOGIN = 'LOGIN';
var LOGOUT = exports.LOGOUT = 'LOGOUT';

exports.default = {
  CHECK: CHECK,
  REGISTER: REGISTER,
  LOGIN: LOGIN,
  LOGOUT: LOGOUT
};

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd26cd6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("iaho");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd26cd6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "MACa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  authenticated: false
};

/***/ }),

/***/ "NHnr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

__webpack_require__("rXZ2");

__webpack_require__("Kkag");

var _vueI18n = __webpack_require__("SwH8");

var _vueRouter = __webpack_require__("sSws");

__webpack_require__("GRgx");

__webpack_require__("y5pl");

__webpack_require__("UbOQ");

__webpack_require__("WlsB");

var _App = __webpack_require__("M93x");

var _App2 = _interopRequireDefault(_App);

var _store = __webpack_require__("IcnI");

var _store2 = _interopRequireDefault(_store);

var _veeValidate = __webpack_require__("sUu7");

var _veeValidate2 = _interopRequireDefault(_veeValidate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.config.productionTip = false;

_store2.default.dispatch('auth/check');

new _vue2.default({
  el: '#app',

  i18n: _vueI18n.i18n,

  router: _vueRouter.router,

  store: _store2.default,

  render: function render(h) {
    return h(_App2.default);
  }
});

_vue2.default.use(_veeValidate2.default);

/***/ }),

/***/ "NhIP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SwH8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.i18n = undefined;

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueI18n = __webpack_require__("TXmL");

var _vueI18n2 = _interopRequireDefault(_vueI18n);

var _locale = __webpack_require__("Vtlw");

var _locale2 = _interopRequireDefault(_locale);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueI18n2.default);

var i18n = exports.i18n = new _vueI18n2.default({
  locale: 'en',
  fallbackLocale: 'en',
  messages: _locale2.default
});

exports.default = {
  i18n: i18n
};

/***/ }),

/***/ "UbOQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("5W1q");

/***/ }),

/***/ "Uz6F":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _auth = __webpack_require__("bfkd");

var auth = _interopRequireWildcard(_auth);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  auth: auth
};

/***/ }),

/***/ "VkTP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutationTypes = __webpack_require__("Xrs4");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _defineProperty3.default)({}, _mutationTypes.FIND, function (state, account) {
  state.email = account.email;
  state.firstName = account.firstName;
  state.lastName = account.lastName;
});

/***/ }),

/***/ "Vtlw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _en = __webpack_require__("77GP");

var _en2 = _interopRequireDefault(_en);

var _nl = __webpack_require__("Uz6F");

var _nl2 = _interopRequireDefault(_nl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  en: _en2.default,
  nl: _nl2.default
};

/***/ }),

/***/ "WlsB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xrs4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FIND = exports.FIND = 'FIND';

exports.default = {
  FIND: FIND
};

/***/ }),

/***/ "bfkd":
/***/ (function(module, exports) {

module.exports = {"failed":"Het inloggen is mislukt","success":"Het inloggen is geslaagd"}

/***/ }),

/***/ "cKSt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.find = undefined;

var _AccountTransformer = __webpack_require__("4HwT");

var _AccountTransformer2 = _interopRequireDefault(_AccountTransformer);

var _mutationTypes = __webpack_require__("Xrs4");

var types = _interopRequireWildcard(_mutationTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var find = exports.find = function find(_ref) {
    var commit = _ref.commit;

    var account = {
        first_name: 'John',
        last_name: 'Doe',
        email: 'jonh@doe.com'
    };

    commit(types.FIND, _AccountTransformer2.default.fetch(account));
};

exports.default = {
    find: find
};

/***/ }),

/***/ "dP9K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseProxy = function () {
  function BaseProxy(endpoint) {
    var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck3.default)(this, BaseProxy);

    this.endpoint = endpoint;
    this.parameters = parameters;
  }

  (0, _createClass3.default)(BaseProxy, [{
    key: 'setParameters',
    value: function setParameters(parameters) {
      var _this = this;

      (0, _keys2.default)(parameters).forEach(function (key) {
        _this.parameters[key] = parameters[key];
      });

      return this;
    }
  }, {
    key: 'setParameter',
    value: function setParameter(parameter, value) {
      this.parameters[parameter] = value;

      return this;
    }
  }, {
    key: 'removeParameters',
    value: function removeParameters(parameters) {
      var _this2 = this;

      parameters.forEach(function (parameter) {
        delete _this2.parameters[parameter];
      });

      return this;
    }
  }, {
    key: 'removeParameter',
    value: function removeParameter(parameter) {
      delete this.parameters[parameter];

      return this;
    }
  }, {
    key: 'submit',
    value: function submit(requestType, url) {
      var _this3 = this;

      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return new _promise2.default(function (resolve, reject) {
        _vue2.default.$http[requestType](url + _this3.getParameterString(), data).then(function (response) {
          resolve(response.data);
        }).catch(function (_ref) {
          var response = _ref.response;

          if (response) {
            reject(response.data);
          } else {
            reject();
          }
        });
      });
    }
  }, {
    key: 'all',
    value: function all() {
      return this.submit('get', '/' + this.endpoint);
    }
  }, {
    key: 'find',
    value: function find(id) {
      return this.submit('get', '/' + this.endpoint + '/' + id);
    }
  }, {
    key: 'create',
    value: function create(item) {
      return this.submit('post', '/' + this.endpoint, item);
    }
  }, {
    key: 'update',
    value: function update(id, item) {
      return this.submit('put', '/' + this.endpoint + '/' + id, item);
    }
  }, {
    key: 'destroy',
    value: function destroy(id) {
      return this.submit('delete', '/' + this.endpoint + '/' + id);
    }
  }, {
    key: 'getParameterString',
    value: function getParameterString() {
      var _this4 = this;

      var keys = (0, _keys2.default)(this.parameters);

      var parameterStrings = keys.filter(function (key) {
        return !!_this4.parameters[key];
      }).map(function (key) {
        return key + '=' + _this4.parameters[key];
      });

      return parameterStrings.length === 0 ? '' : '?' + parameterStrings.join('&');
    }
  }]);
  return BaseProxy;
}();

exports.default = BaseProxy;

/***/ }),

/***/ "eOO6":
/***/ (function(module, exports) {

module.exports = {"failed":"Login failed","success":"Login successful"}

/***/ }),

/***/ "fHbC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.logout = exports.login = exports.register = exports.check = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _store = __webpack_require__("IcnI");

var _store2 = _interopRequireDefault(_store);

var _AuthProxy = __webpack_require__("1AQK");

var _AuthProxy2 = _interopRequireDefault(_AuthProxy);

var _mutationTypes = __webpack_require__("M0FW");

var types = _interopRequireWildcard(_mutationTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var check = exports.check = function check(_ref) {
    var commit = _ref.commit;

    commit(types.CHECK);
};

var register = exports.register = function register(_ref2) {
    var commit = _ref2.commit;

    commit(types.LOGIN, 'RandomGeneratedToken');
    _vue2.default.router.push({
        name: 'home.index'
    });
};

var login = exports.login = function login(_ref3, user) {
    var commit = _ref3.commit;

    console.log(user);
    return new _promise2.default(function (resolve, reject) {
        new _AuthProxy2.default().login(user).then(function (response) {
            commit(types.LOGIN, response);
            _store2.default.dispatch('account/find');
            _vue2.default.router.push({
                name: 'dharmams.index'
            });
            resolve(response);
        }).catch(function () {
            reject();
        });
    });
};

var logout = exports.logout = function logout(_ref4) {
    var commit = _ref4.commit;

    commit(types.LOGOUT);
    _vue2.default.router.push({
        name: 'login.index'
    });
};

exports.default = {
    check: check,
    register: register,
    login: login,
    logout: logout
};

/***/ }),

/***/ "g8Jr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  email: null,
  firstName: null,
  lastName: null
};

/***/ }),

/***/ "iMZk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutationTypes = __webpack_require__("Jqq7");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _defineProperty3.default)({}, _mutationTypes.FIND, function (state, dharmam) {
    state.id = dharmam.id;
    state.name = dharmam.name;
    state.title = dharmam.title;
    state.text = dharmam.text;
    state.apiKey = dharmam.apiKey;
    state.apiSecret = dharmam.apiSecret;
});

/***/ }),

/***/ "iaho":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iwwM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),

/***/ "jTsY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    dharmams: [{
        id: 1,
        name: 'gosala',
        title: 'Gosamrakshanam'
    }, {
        id: 2,
        name: 'veda-patasala',
        title: 'Veda Patasala'
    }, {
        id: 3,
        name: 'annadhanam',
        title: 'Annadhanam'
    }, {
        id: 4,
        name: 'others',
        title: 'Others'
    }, {
        id: 5,
        name: 'brahmotsavam',
        title: 'Brahmotsavam'
    }, {
        id: 6,
        name: 'jayanthi-utsavam',
        title: 'Sri Sri Jayanthi Utsavam'
    }, {
        id: 7,
        name: 'srisrijayanthi',
        title: 'Sri Krishnapremi Swamigal 80th Jayanth Utsav Committee'
    }, {
        id: 8,
        name: 'srimadhuri',
        title: 'Sri Madhuri Kalyana Mandapa Thiruppani Committee'
    }, {
        id: 9,
        name: 'brahma-sabha',
        title: 'Brahma Sabha Trust'
    }]
};

/***/ }),

/***/ "m3mU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _CHECK$REGISTER$LOGIN;

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _jsCookie = __webpack_require__("lbHh");

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _mutationTypes = __webpack_require__("M0FW");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (_CHECK$REGISTER$LOGIN = {}, (0, _defineProperty3.default)(_CHECK$REGISTER$LOGIN, _mutationTypes.CHECK, function (state) {
    state.authenticated = _jsCookie2.default.get('authenticated') == "true";
}), (0, _defineProperty3.default)(_CHECK$REGISTER$LOGIN, _mutationTypes.REGISTER, function () {}), (0, _defineProperty3.default)(_CHECK$REGISTER$LOGIN, _mutationTypes.LOGIN, function (state, token) {
    state.authenticated = true;

    _jsCookie2.default.set('authenticated', 'true', { expires: 1 });
}), (0, _defineProperty3.default)(_CHECK$REGISTER$LOGIN, _mutationTypes.LOGOUT, function (state) {
    state.authenticated = false;
    _jsCookie2.default.remove('authenticated');
}), _CHECK$REGISTER$LOGIN);

/***/ }),

/***/ "rXZ2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__("NYxO");

var _vuex2 = _interopRequireDefault(_vuex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

/***/ }),

/***/ "sSws":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.router = undefined;

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _routes = __webpack_require__("DP/h");

var _routes2 = _interopRequireDefault(_routes);

var _store = __webpack_require__("IcnI");

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var router = exports.router = new _vueRouter2.default({
    routes: _routes2.default,
    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    }
});
router.beforeEach(function (to, from, next) {
    if (to.matched.some(function (m) {
        return m.meta.auth;
    }) && !_store2.default.state.auth.authenticated) {
        next({
            name: 'login.index'
        });
    } else if (to.matched.some(function (m) {
        return m.meta.guest;
    }) && _store2.default.state.auth.authenticated) {
        next({
            name: 'home.index'
        });
    } else {
        next();
    }
});

_vue2.default.router = router;

exports.default = {
    router: router
};

/***/ }),

/***/ "wz9i":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Transformer = function () {
  function Transformer() {
    (0, _classCallCheck3.default)(this, Transformer);
  }

  (0, _createClass3.default)(Transformer, null, [{
    key: "fetchCollection",
    value: function fetchCollection(items) {
      var _this = this;

      return items.map(function (item) {
        return _this.fetch(item);
      });
    }
  }, {
    key: "sendCollection",
    value: function sendCollection(items) {
      var _this2 = this;

      return items.map(function (item) {
        return _this2.send(item);
      });
    }
  }]);
  return Transformer;
}();

exports.default = Transformer;

/***/ }),

/***/ "xJD8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'srisri-dharmams',

  mounted: function mounted() {
    if (this.$store.state.auth.authenticated) {
      this.$store.dispatch('account/find');
    }
  }
};

/***/ }),

/***/ "y5pl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("NhIP");

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.ab5dca69178499f9a322.js